export interface SurveyVariable {
    id: string;
    variable_name: string;
    variable_type: VariableType;
    include_in_url: boolean;
    is_unique_id: boolean;
  }

  export enum VariableType {
    TEXT = 'text',
    NUMBER = 'number',
  }